import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router';
import { SurekeepShell } from '../../components/layouts/SurekeepShell';
import { MFA_SETUP_AREA, requireSession } from '../../lib/authGuard';
import { useAuth } from '../../hooks/useAuth';
import { ProfileGate } from '@/shared/patterns/AppShell/ProfileGate';

function AuthenticatedLayout() {
    const { user } = useAuth();
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    // Durante el setup FORZADO de 2º factor (mfaSetupRequired) la pantalla es STANDALONE —
    // sin el menú lateral, igual que la de nueva contraseña. El user todavía no "entró" a la app.
    const forcedSetup = !!user?.mfaSetupRequired && pathname.startsWith(MFA_SETUP_AREA);
    if (forcedSetup) return <Outlet />;
    return (
        <ProfileGate>
            <SurekeepShell>
                <Outlet />
            </SurekeepShell>
        </ProfileGate>
    );
}

export const Route = createFileRoute('/_authenticated/_layout')({
    // Sesión + gate de 2º factor; un error al leer el perfil no manda a /login.
    beforeLoad: ({ context, location }) => requireSession(context.auth, location.pathname),
    component: AuthenticatedLayout,
});
